// Penz Kurulumu: rehberli akış durumu (yalnızca bu sekme). Adım tamamlanması gerçek veriden gelir.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const SETUP_STEPS = [
  { key: "customer", label: "İlk müşteri", path: "/customers", title: "İlk müşterinizi ekleyin",
    text: "Penz’de işler, tahsilatlar ve müşteri kârlılığı müşteri kaydıyla başlar.", cta: "Müşteri Oluştur" },
  { key: "job", label: "İlk iş / satış", path: "/jobs", title: "İlk işinizi oluşturun",
    text: "Yaptığınız işi, tutarını ve tahsilat sürecini Penz'de takip edin.", cta: "İş Oluştur" },
  { key: "supplier", label: "İlk tedarikçi", path: "/vendors", title: "Tedarikçiyle çalışıyor musunuz?",
    text: "Tedarikçilerinizi kaydederek borçlarınızı ve satın almalarınızı takip edebilirsiniz.", cta: "Tedarikçi Oluştur" },
  { key: "purchase", label: "İlk satın alma", path: "/purchases", title: "İlk satın almanızı ekleyin",
    text: "Bir müşteriye veya işe bağlı satın almalarınızı ekleyerek gerçek kârlılığı görün.", cta: "Satın Alma Oluştur" },
  { key: "expense", label: "İlk gider", path: "/expenses", title: "İlk giderinizi ekleyin",
    text: "İşletme giderlerinizi kaydedin ve net nakit durumunuzu doğru görün.", cta: "Gider Oluştur" },
];

const KEY = "penz_setup_flow";

export function getFlow() {
  try { return JSON.parse(window.sessionStorage.getItem(KEY)) || null; } catch (_) { return null; }
}
export function saveFlow(flow) {
  try {
    if (flow) window.sessionStorage.setItem(KEY, JSON.stringify(flow));
    else window.sessionStorage.removeItem(KEY);
  } catch (_) { /* yok say */ }
}

// Rehberli akışta, idx'ten itibaren tamamlanmamış ilk adım.
export function nextStepIndex(flow, steps) {
  if (!flow) return -1;
  for (let i = flow.idx; i < SETUP_STEPS.length; i += 1) {
    if (!steps?.[SETUP_STEPS[i].key]) return i;
  }
  return -1;
}

export function rememberSetupCustomer(id) {
  const f = getFlow();
  if (f && f.awaiting === "customer") saveFlow({ ...f, lastCustomerId: id });
}

export function setupDefaultCustomerId() {
  return getFlow()?.lastCustomerId || "";
}

// Kurulumdan açılan form kapandığında (kayıt ya da vazgeç) Dashboard'a dön.
export function useSetupReturn(entity, open) {
  const navigate = useNavigate();
  const prev = useRef(false);
  useEffect(() => {
    if (prev.current && !open) {
      const f = getFlow();
      if (f && f.awaiting === entity) {
        saveFlow({ ...f, awaiting: null });
        navigate("/");
      }
    }
    prev.current = !!open;
  }, [open, entity, navigate]);
}

export function isSetupEligible(user) {
  return !!user && user.subscription_status === "trial" && user.is_internal_account !== true
    && user.account_status === "active";
}
